export default __webpack_public_path__ + "static/media/ic_type_recipe.9bf8eb18.svg";